"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutOfTimeAbilityHandler = exports.OutOfTimeActorAbilityFactory = exports.OutOfTimeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/event-handlers/core");
class OutOfTimeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.OutOfTime;
        this.__typeName = "OutOfTime";
    }
}
exports.OutOfTimeAbilityArgs = OutOfTimeAbilityArgs;
let OutOfTimeActorAbilityFactory = class OutOfTimeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("OutOfTime", "Self", 0);
    }
};
OutOfTimeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("OutOfTime")
], OutOfTimeActorAbilityFactory);
exports.OutOfTimeActorAbilityFactory = OutOfTimeActorAbilityFactory;
let OutOfTimeAbilityHandler = class OutOfTimeAbilityHandler {
    init(sequence, container, actorId) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: "OutOfTime",
            animatedId: actorId,
            fallback: "blocked",
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    hidden: true,
                    creatorId: actorId,
                    targetId: actorId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.AvoidDeathEffectArgs(),
                    onApplied: () => {
                        container.registerEventHandler(actorId, EventType_1.EventType.DeathAvoided, Schedule_1.Schedule.Unlimited, new core_2.CustomScriptEventHandlerArgs("Ability_OutOfTime_OnDeathAvoided", {
                            ticks: 11
                        }));
                    },
                    supernatural: true,
                });
            }
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
OutOfTimeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.OutOfTime)
], OutOfTimeAbilityHandler);
exports.OutOfTimeAbilityHandler = OutOfTimeAbilityHandler;
